export default __webpack_public_path__ + "static/media/photo--sm--hockey5.f87ab6b3.jpg";